module.exports = __webpack_public_path__ + "static/LeadsheetExample-136c6746df7dfbc4996c844a0f336676.png";